// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderHis_wrapper__CQ1cL","id-order":"OrderHis_id-order__4Qnt6","address":"OrderHis_address__MFjx5","time":"OrderHis_time__EiTwJ","price":"OrderHis_price__DV9sq"};